module.exports = __webpack_public_path__ + "static/media/lingmingshan5.8dffe314.jpg";